import React from "react";
import { useTranslation } from "react-i18next";

import Link from "../Link";
import { getObjectValByString } from "../../utils";

const convertOtherToFaqs = (items, questionNode, contentNode) => {
  const faqEdges = items.edges.map(({ node }) => ({
    node: {
      acfFaqs: {
        question: getObjectValByString(questionNode, node),
        content: getObjectValByString(contentNode, node),
      },
    },
  }));

  return { edges: faqEdges };
};

export const convertPartialsToFaqs = (items) =>
  convertOtherToFaqs(items, "acfPartials.pHeading", "acfPartials.pContent");
export const convertSupportCentreToFaqs = (items) =>
  convertOtherToFaqs(items, "title", "content");

const Faq = ({ id, content, visitSupportUrl, customVisitButton }) => {
  const { t } = useTranslation();
  return (
    <>
      {content.edges.length > 0 && (
        <div id={id} className="faq" style={{ padding: "8rem 0" }}>
          <div className="container py-5">
            <div className="text-center">
              <h2 style={{ marginBottom: "4rem" }}>{t("common.faq.title")}</h2>
            </div>

            <div className="accordion" id="generalFaq">
              {content.edges.map((post, i) => (
                <div className="accordion-wrapper" key={i}>
                  <div className="card-header" id={`generalFaq-${i}`}>
                    <h5 className={`mb-0`}>
                      <button
                        className="btn btn-link btn-block text-left px-0 collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapseZipUpFaq-${i}`}
                        aria-expanded="false"
                        aria-controls={`collapseZipUpFaq-${i}`}
                      >
                        {post.node.acfFaqs.question}{" "}
                        <svg
                          width="12"
                          height="13"
                          viewBox="0 0 12 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ float: "right" }}
                        >
                          <path
                            d="M11.1429 5.64286H6.85714V1.35714C6.85714 0.885714 6.47143 0.5 6 0.5C5.52857 0.5 5.14286 0.885714 5.14286 1.35714V5.64286H0.857143C0.385714 5.64286 0 6.02857 0 6.5C0 6.97143 0.385714 7.35714 0.857143 7.35714H5.14286V11.6429C5.14286 12.1143 5.52857 12.5 6 12.5C6.47143 12.5 6.85714 12.1143 6.85714 11.6429V7.35714H11.1429C11.6143 7.35714 12 6.97143 12 6.5C12 6.02857 11.6143 5.64286 11.1429 5.64286Z"
                            fill="#A8B2BD"
                          />
                        </svg>
                      </button>
                    </h5>
                  </div>
                  <div
                    id={`collapseZipUpFaq-${i}`}
                    className="collapse"
                    aria-labelledby={`generalFaq-${i}`}
                    data-parent="#generalFaq"
                  >
                    <div className="card-body">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.node.acfFaqs.content,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              {visitSupportUrl && !customVisitButton && (
                <div
                  className="faq-bottom-link__wrapper"
                  style={{ marginTop: "3rem" }}
                >
                  <Link className="faq-bottom-link" to={visitSupportUrl}>
                    {t("common.faq.visitSupport")} &#187;
                  </Link>
                </div>
              )}
              {customVisitButton}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
